import * as types from './types';

const INITIAL_STATE = {
  reimbursementRates: [],
  fetching: false,
  fetchError: null,
  selectedReimbursementRate: null,
  success: false,
  formData: null,
  cancelChange: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.REIMBURSEMENT_RATES_GET_REIMBURSEMENT_RATES:
      return {
        ...state,
        reimbursementRates: action.payload.data,
      };

    case types.REIMBURSEMENT_RATES_CLEAR_FETCH_ERROR:
      return {
        ...state,
        fetchError: null,
      };
    case types.REIMBURSEMENT_RATE_CLEAR_FORM_DATA:
      return {
        ...state,
        formData: null,
        selectedReimbursementRate: null,
        fetchError: null,
      };

    case types.REIMBURSEMENT_RATE_SET_FORM_DATA:
      return {
        ...state,
        formData: action.payload,
        fetchError: null,
      };

    case types.REIMBURSEMENT_RATES_FETCHING:
      return { ...state, fetching: action.payload };

    case types.REIMBURSEMENT_RATES_SET_REIMBURSMENT_RATE:
      return {
        ...state,
        selectedReimbursementRate: action.payload,
      };

    case types.REIMBURSEMENT_RATES_FETCH_ERROR:
      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message: action.payload
            ? action.payload
            : 'An error has occurred. Please try again',
        },
      };

    case types.REIMBURSEMENT_RATE_SETSUCCESS:
      return {
        ...state,
        success: action.payload,
      };

    case types.REIMBURSEMENT_RATE_CANCEL_CHANGE:
      return {
        ...state,
        cancelChange: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reimbursementrates/state/rates/reducer.js